import Vue from "vue";

import { PicturesStoreState } from "@/shared/interfaces/Pictures.interface";
import { Picture } from "@/shared/interfaces/Picture.interface";

import { getObjetIndexByKey } from "@/shared/scripts/helpers/array";
import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { RootState } from "../../store.interface";
import { toOptimizedPictureUrl } from "@/shared/scripts/mediaResize";

const state: PicturesStoreState = {
    pictures: Array<Picture>(),
    errorMessage: "",
    deletedPictures: Array<string>(),
    deleteOnCancel: Array<string>()
};

const mutations: MutationTree<PicturesStoreState> = {
    setPictures: function(state: PicturesStoreState, pictures: Array<Picture>): void {
        const transformed = pictures.map(picture => ({
            ...picture,
            url: toOptimizedPictureUrl(picture.url)
        }));
        state.pictures = transformed;
    },
    addPicture: function(state: PicturesStoreState, picture: Picture): void {
        const newPic = {
            ...picture,
            url: toOptimizedPictureUrl(picture.url)
        };
        state.pictures.push(newPic);
    },
    replacePicture: function(state: PicturesStoreState, picture: Picture): void {
        if (picture.id) {
            const pictureIndex = getObjetIndexByKey(state.pictures as Array<Picture>, "id", picture.id);

            if (pictureIndex !== -1) {
                const newPic = {
                    ...picture,
                    url: toOptimizedPictureUrl(picture.url)
                };
                Vue.set(state.pictures, pictureIndex, newPic);
            }
        }
    },
    setErrorMessage: function(state: PicturesStoreState, errorMessage: string): void {
        state.errorMessage = errorMessage;
    },
    removePicture: function(state: PicturesStoreState, picture: Picture): void {
        state.pictures = state.pictures.filter(item => item.id !== picture.id);

        // Do not add 'upload_' named pictures in the array
        if(picture.id && !picture.id.startsWith("upload_")) {
            state.deletedPictures.push(picture.id);
        }
    },
    setAsMainPicture: function(state: PicturesStoreState, picture: Picture) : void {
        const newPicture = picture;
        state.pictures = state.pictures.filter(item => item.id !== picture.id);
        state.pictures.unshift(newPicture);
    },
    addDeleteOnCancel: function(state: PicturesStoreState, id: string): void {
        state.deleteOnCancel.push(id);
    },
    resetDeleteOnCancel: function(state: PicturesStoreState): void {
        state.deleteOnCancel = [];
    },
    resetDeletedPictures: function(state: PicturesStoreState): void {
        state.deletedPictures = [];
    }
};

const getters: GetterTree<PicturesStoreState, RootState> = {
    getPictures: (state: PicturesStoreState): Array<Picture> => {
        return state.pictures;
    },
    getErrorMessage: (state: PicturesStoreState): string => {
        return state.errorMessage;
    },
    getDeletedPictures: (state: PicturesStoreState): Array<string> => {
        return state.deletedPictures;
    },
    getDeleteOnCancel: (state: PicturesStoreState): Array<string> => {
        return state.deleteOnCancel;
    }
};

const actions: ActionTree<PicturesStoreState, RootState> = {
    removePicture: function({commit}, picture: Picture) {
        commit("removePicture", picture);
    },
    addDeleteOnCancel: function({commit}, id: string) {
        commit("addDeleteOnCancel", id);
    },
    resetDeleteOnCancel: function({commit}) {
        commit("resetDeleteOnCancel");
    },
    resetDeletedPictures: function({commit}) {
        commit("resetDeletedPictures");
    },

};


const pictures: Module<PicturesStoreState, RootState> = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};

export default pictures;
